import { debounce } from '@fe/core';
import { Button } from '@progress/kendo-react-buttons';
import React from 'react';
import { ColorPickerWithDefault } from '../../../../../app/components/inputs/ColorPickerWithDefault';
import { RefreshOutline } from '../../../../../icons/icons';
import { SettingsStringKeys } from '../../../../../services/settings-service';
import { useAppDispatch } from '../../../../hooks/store-hooks';
import { setSetting } from '../../../../state/slices/settings-slice';
import { store } from '../../../../state/store';

const defaultColors: Partial<Record<SettingsStringKeys, string>> = {
    etopsBorderFillColor: 'rgba(0, 75, 148, 0.08)',
    etopsBorderOutlineColor: 'rgba(0, 75, 148, .39)',
    etopsRuleFillColor: 'rgba(128, 128, 128, 0.05)',
    etopsRuleOutlineColor: 'rgba(128, 128, 128, .39)',
    etopsPointColor: 'rgba(50, 50, 255, .69)',
    etopsAirportColor: '#000'
};

export default function SettingsEtops() {
    return (
        <div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '1rem', rowGap: '0.5rem' }}>
                <Element name="Border Ring fill" settingKey="etopsBorderFillColor" />
                <Element name="Border Ring outline" settingKey="etopsBorderOutlineColor" />

                <Element name="Rule Ring fill" settingKey="etopsRuleFillColor" />
                <Element name="Rule Ring outline" settingKey="etopsRuleOutlineColor" />

                <Element name="Points" settingKey="etopsPointColor" />
                <Element name="Airports" settingKey="etopsAirportColor" />
            </div>
            <div className="d-flex justify-content-end pt-2 d-none">
                <Button svgIcon={RefreshOutline} themeColor={'primary'}>
                    Restore defaults
                </Button>
            </div>
        </div>
    );
}

function Element(props: { name: string; settingKey: SettingsStringKeys }) {
    const dispatch = useAppDispatch();

    const initialValue = store.getState().settings[props.settingKey] ?? '';
    const [value, setValue] = React.useState(initialValue);

    const save = React.useCallback(
        debounce((color: string) => {
            dispatch(setSetting(props.settingKey, color));
        }, 1000),
        []
    );

    console.log(defaultColors[props.settingKey], 'defaultColors[props.settingKey]');
    return (
        <div className="d-flex justify-content-between align-items-center gap-2">
            <div>{props.name}</div>
            <ColorPickerWithDefault
                defaultColor={defaultColors[props.settingKey]}
                views={['palette', 'gradient']}
                value={value}
                onChange={(e) => {
                    setValue(e.value);
                    save(e.value);
                }}
            />
        </div>
    );
}
